/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, metric: NonNullable<unknown>, leftValue: NonNullable<unknown>, rightChain: NonNullable<unknown>, rightValue: NonNullable<unknown> }} Chain_Page_Compare_ValuesInputs */



/**
* | output |
* | --- |
* | "{leftChain} {metric} is {leftValue}, while {rightChain} {metric} is {rightValue}" |
*
* @param {Chain_Page_Compare_ValuesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_values = /** @type {((inputs: Chain_Page_Compare_ValuesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_ValuesInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} ${i?.metric} is ${i?.leftValue}, while ${i?.rightChain} ${i?.metric} is ${i?.rightValue}`)
});